import { BASE_URL, request } from '@/lib/api'

/**
 * Один вид уведомлений: центр — всегда, почта — по выбору (#118), push — пока не выключен
 * (#120). `push` сравнивается нестрого: в старом ответе его нет, и это значит «включён».
 */
export interface KindSetting {
  kind: string
  inApp: boolean
  email: boolean
  push?: boolean
}

/**
 * Настройки доставки своих уведомлений.
 *
 * `address` отсутствует в ответе, когда у учётной записи нет почты (сервер не отдаёт
 * null-поля), поэтому сравнивать его надо нестрого.
 */
export interface NotificationPreferences {
  address?: string | null
  mailConnected: boolean
  /** Сколько устройств сейчас получают push; 0 — переключателям push некуда доставлять. */
  pushDevices?: number
  kinds: KindSetting[]
}

export function fetchNotificationPreferences(signal?: AbortSignal): Promise<NotificationPreferences> {
  return request<NotificationPreferences>('/notifications/preferences', { signal })
}

/** Сохраняет почту и push по видам; не названные виды сервер не трогает. */
export function saveNotificationPreferences(
  email: Record<string, boolean>,
  push?: Record<string, boolean>,
): Promise<NotificationPreferences> {
  return request<NotificationPreferences>('/notifications/preferences', {
    method: 'PUT',
    body: push ? { email, push } : { email },
  })
}

/** Чем закончилась отписка по ссылке из письма. */
export type UnsubscribeResult =
  | { ok: true; kind: string }
  | { ok: false; status: number }

/**
 * Отписка без входа: обычный `fetch`, а не `request` — у читателя письма может не быть
 * сессии, а `request` на 401 уводил бы на страницу входа, то есть ровно туда, куда отписка
 * идти не должна.
 */
export async function unsubscribe(token: string): Promise<UnsubscribeResult> {
  const response = await fetch(
    `${BASE_URL}/public/notifications/unsubscribe?token=${encodeURIComponent(token)}`,
    { method: 'POST', headers: { Accept: 'application/json' } },
  )
  if (!response.ok) return { ok: false, status: response.status }
  const body = (await response.json()) as { kind: string }
  return { ok: true, kind: body.kind }
}
